import { cn } from '@/lib/utils'

/**
 * Top-bar pill grammar shared by the editor's mode switcher (Create / Edit)
 * and the workspace tabs (Projects / Library / Settings) — one source so the
 * two bars can't drift apart. Icon-then-label, active = quiet filled pill.
 */
export const navPill = (active: boolean) =>
  cn(
    'flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors select-none',
    active ? 'bg-secondary/60 text-foreground' : 'text-muted-foreground hover:text-foreground/90',
  )
